import { RootState } from "@/modules/common";

export const selectUseBalance = (state: RootState) => state.basket.useBalance;
